import AddRoundedIcon from '@mui/icons-material/AddRounded';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import CelebrationRoundedIcon from '@mui/icons-material/CelebrationRounded';
import ChatRoundedIcon from '@mui/icons-material/ChatRounded';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import DescriptionRoundedIcon from '@mui/icons-material/DescriptionRounded';
import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded';
import EventRoundedIcon from '@mui/icons-material/EventRounded';
import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded';
import HelpRoundedIcon from '@mui/icons-material/HelpRounded';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import LightbulbRoundedIcon from '@mui/icons-material/LightbulbRounded';
import LinkRoundedIcon from '@mui/icons-material/LinkRounded';
import MailRoundedIcon from '@mui/icons-material/MailRounded';
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';
import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';
import ScheduleRoundedIcon from '@mui/icons-material/ScheduleRounded';
import SchoolRoundedIcon from '@mui/icons-material/SchoolRounded';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import SnoozeRoundedIcon from '@mui/icons-material/SnoozeRounded';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import ThumbDownRoundedIcon from '@mui/icons-material/ThumbDownRounded';
import ThumbUpRoundedIcon from '@mui/icons-material/ThumbUpRounded';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';

const noticeIcons = {
  add: AddRoundedIcon,
  arrow_back: ArrowBackRoundedIcon,
  arrow_forward: ArrowForwardRoundedIcon,
  celebration: CelebrationRoundedIcon,
  chat: ChatRoundedIcon,
  check: CheckRoundedIcon,
  close: CloseRoundedIcon,
  description: DescriptionRoundedIcon,
  download: DownloadRoundedIcon,
  edit: EditRoundedIcon,
  error: ErrorRoundedIcon,
  event: EventRoundedIcon,
  favorite: FavoriteRoundedIcon,
  help: HelpRoundedIcon,
  info: InfoRoundedIcon,
  lightbulb: LightbulbRoundedIcon,
  link: LinkRoundedIcon,
  mail: MailRoundedIcon,
  notifications: NotificationsRoundedIcon,
  open_in_new: OpenInNewRoundedIcon,
  play: PlayArrowRoundedIcon,
  refresh: RefreshRoundedIcon,
  schedule: ScheduleRoundedIcon,
  school: SchoolRoundedIcon,
  settings: SettingsRoundedIcon,
  snooze: SnoozeRoundedIcon,
  star: StarRoundedIcon,
  thumb_down: ThumbDownRoundedIcon,
  thumb_up: ThumbUpRoundedIcon,
  warning: WarningRoundedIcon,
};

export default noticeIcons;
